import _ from 'lodash'
import store from '@/store'
import * as types from '@/store/types'
import SimpleVueValidator from 'simple-vue-validator';
const Validator = SimpleVueValidator.Validator;

const airMofaMixin = {
    validators: {
      'mofa.travel_date': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.aircraft_signal_call': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.registration_no': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.landing_permit_no' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.leasing_company' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.aircraft_type' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.icao_route' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.flight_itinerary' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'mofa.cargo_details' : function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      }
    }
  }

export default airMofaMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/AirMofa-validators.js